import { useState } from 'react';
import { Card, SegmentedControl } from '@salonomy/ui';
import { PackageLiabilityPanel, PackagesPanel } from '../features/packages/index.js';
import { useAuth } from '../lib/auth.js';

type Tab = 'catalogue' | 'liability';

const TABS: Array<{ value: Tab; label: string }> = [
  { value: 'catalogue', label: 'Catalogue' },
  { value: 'liability', label: 'Liability' },
];

/**
 * WS-13 Feature 3a — the prepaid packages page: Catalogue | Liability, on the standard screen-scroll /
 * screen-pad / topbar layout (mirroring StockPage). Self-gated to managers: every catalogue WRITE and the
 * liability report are manager-only on the API, so a non-manager gets an honest note rather than a
 * guaranteed 403. Selling and redeeming a package happen at the till.
 */
export function PackagesPage() {
  const { isManager } = useAuth();
  const [tab, setTab] = useState<Tab>('catalogue');

  if (!isManager) {
    return (
      <>
        <div className="topbar">
          <div className="topbar__title">Packages</div>
        </div>
        <div className="screen-scroll">
          <div
            className="screen-pad"
            style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 980 }}
          >
            <Card>
              <div className="section-title">Packages are manager-only</div>
              <div className="muted" style={{ fontSize: 13, marginTop: 8, lineHeight: 1.5 }}>
                The package catalogue and the liability report are managed by an owner or manager.
                Ask one of them to add a prepaid course or stored-value package. You can still sell
                and redeem packages at the till as normal.
              </div>
            </Card>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="topbar">
        <div className="topbar__left">
          <div className="topbar__title">Packages</div>
        </div>
        <div className="topbar__right">
          <SegmentedControl options={TABS} value={tab} onChange={setTab} />
        </div>
      </div>

      <div className="screen-scroll">
        <div
          className="screen-pad"
          style={{ display: 'flex', flexDirection: 'column', gap: 20, maxWidth: 980 }}
        >
          {tab === 'catalogue' ? <PackagesPanel /> : null}
          {tab === 'liability' ? <PackageLiabilityPanel enabled={tab === 'liability'} /> : null}
        </div>
      </div>
    </>
  );
}
